module.exports = __webpack_public_path__ + "img/about-2-1.553bfccc.jpeg";